export function IconSettings({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Zentraler Kreis */}
      <circle cx="12" cy="12" r="3" />
      {/* 8 Spike-Lines: 4 kardinal + 4 diagonal */}
      <path d="M12 2 v3 M12 19 v3 M2 12 h3 M19 12 h3 M5.6 5.6 l2 2 M16.4 16.4 l2 2 M5.6 18.4 l2-2 M16.4 7.6 l2-2" />
    </svg>
  );
}
